import { IRoute, Routes } from './route';

// menu phía đầu
export const BeforeRouteMenus: IRoute[] = [Routes.HOME, Routes.POS];

// menu phía cuối
export const AfterRouteMenus: IRoute[] = [
  { ...Routes.SETTING, children: [Routes.GENERAL_SETTING, Routes.LICENSE, Routes.SOCIAL, Routes.PAYMENT] },
];
